import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { officeDataSelector } from '@selectors/global';

const SidebarRdsNameWidget = ({ style }) => {
  const office = useSelector(officeDataSelector);

  return (
    <SidebarRdsNameWidget.Wrapper>
      <SidebarRdsNameWidget.Text style={style ? style : {}}>
        {office}
      </SidebarRdsNameWidget.Text>
    </SidebarRdsNameWidget.Wrapper>
  );
};

SidebarRdsNameWidget.propTypes = {
  style: PropTypes.any,
};

SidebarRdsNameWidget.Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  padding-left: 5px;
`;

SidebarRdsNameWidget.Text = styled.div`
  font-family: Arial;
`;

export default SidebarRdsNameWidget;
